import { useImpersonation } from "providers/impersonation";

export const useImpersonationRestriction = () => {
  const { isImpersonating, canActOnBehalf } = useImpersonation();
  
  const shouldRestrict = isImpersonating && !canActOnBehalf;
  
  return { shouldRestrict };
};
